import {Component, ElementRef, forwardRef, Inject, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import { AspectRatio, Image, ImageSize } from '../model/image';
import { TourApiService } from '../services/tour-api.service';
import { EnumAware } from '../decorators/enum-aware.decorator';
import { ModalService } from '../services/modal.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@EnumAware
@Component({
  selector: 'gt-image-list',
  templateUrl: './image-list.component.html',
  styleUrls: ['./image-list.component.css']
})

export class ImageListComponent implements OnInit {

  AspectRatio = AspectRatio;
  ImageSize = ImageSize;
  currentImage: Image;
  wrapperStyleString = '67%';
  @Input() imageList: Image[] = [];
  @Input() imageRatio: AspectRatio = AspectRatio.Rectangle;
  @ViewChild('mainImage') mainImage: ElementRef;

  constructor(public apiService: TourApiService,
              @Inject(forwardRef(() => ModalService)) public modalService) {}

  ngOnInit() {
    // this._imageList = list;
    this.currentImage = this.imageList[0];
  }

  wrapperClass(): string {
    return (this.imageRatio === AspectRatio.Square) ? 'square-image-wrapper' : 'rectangle-image-wrapper';
  }

  setWrapperStyle(el: ElementRef) {
    if (this.imageRatio === AspectRatio.Square) {
      this.wrapperStyleString = '100%';
    } else {
      const percent = Math.round((this.mainImage.nativeElement.naturalHeight / this.mainImage.nativeElement.naturalWidth) * 100);
      this.wrapperStyleString = percent + '%';
    }
  }
  largeImageClass(): string {
    return (this.imageRatio === AspectRatio.Square) ? 'square-image-large' : 'rectangle-image-large';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/image-list.component.ts